export const capitalize = (str: string) => {
  const capitalizeFirstChar = str?.charAt(0)?.toUpperCase();
  const excludeFirstChar = str.slice(1, str.length);
  const capitalizeStr = capitalizeFirstChar + excludeFirstChar;
  return capitalizeStr;
};
